module.exports = __webpack_public_path__ + "media/virtual-gallery/GalleryOfTheirOwn-x2-1b96902b.jpg";